import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import GoogleIcon from '@mui/icons-material/Google';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getReturnPath } from '../helpers/returnPath';

const Login = () => {
  const { signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = getReturnPath(location.state?.from);

  const handleLogin = async () => {
    try {
      await signInWithGoogle();
      navigate(from, { replace: true });
    } catch (err) {
      console.error('Login failed', err);
      alert('Login fehlgeschlagen. Details siehe Konsole.');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 420, width: '100%' }} elevation={3}>
        <Typography variant="h5" gutterBottom>
          JMG Admin Login
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Please sign in with Google to access the admin interface.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          startIcon={<GoogleIcon />}
          onClick={handleLogin}
        >
          Sign in with Google
        </Button>
        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 2, flexWrap: 'wrap' }} useFlexGap>
          <Link component={RouterLink} to="/privacy-policy" underline="hover">
            Privacy Policy
          </Link>
          <Typography variant="body2" color="text.secondary">
            |
          </Typography>
          <Link href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer" underline="hover">
            YouTube Terms
          </Link>
        </Stack>
      </Paper>
    </Box>
  );
};

export default Login;
